<style scoped>
.login{
    width: 100%;
    height: 400px;
    text-align: center;
    background: url("../../assets/imgs/login.png");
    background-size: 100%;
    background-repeat:no-repeat;
}
.loginCard{
  width: 400px;
  margin: 150px auto;
}
.loginCode{
  width:150px;
  font-size: x-large;
  background-color: darkgrey
}
</style>

<template>
    <div class="login" @keydown.enter="handleSubmit">
        <Card class="loginCard">
          <h1 class="p-t-20">私有化登录</h1>
          <Alert type="error" show-icon v-show="pageView.showMessage">{{pageView.message}}</Alert>
          <Form class="p-t-20" ref="formInline" :model="formInline" :rules="ruleInline">
              <FormItem prop="user">
                  <i-input type="text" v-model="formInline.user" placeholder="用户名">
                      <Icon type="ios-person-outline" slot="prepend"></Icon>
                  </i-input>
              </FormItem>
              <FormItem prop="password">
                  <i-input type="password"  :password="true" v-model="formInline.password" placeholder="密码">
                      <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </i-input>
              </FormItem>
              <FormItem prop="code">
                <i-input type="text" v-model="formInline.code" placeholder="验证码">
                    <Button slot="append" class="loginCode" @click="generatedCode">{{ccode}}</Button>
                </i-input>
              </FormItem>
              <FormItem>
                  <Button type="error" long size="large" @click="handleSubmit">LOGIN</Button>
              </FormItem>
          </Form>
        </Card>
    </div>
</template>

<script>
import { loginByUsername } from '@/api/login'
import { checkReturnUrl } from '@/utils/main'
const CryptoJS = require('crypto-js')

export default {
  data () {
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else if (value.toUpperCase() !== this.ccode) {
        callback(new Error('验证码不正确'))
      } else {
        callback()
      }
    }
    return {
      pageView: {
        showMessage: false,
        message: ''
      },
      formInline: {
        code: '',
        user: '',
        password: ''
      },
      ruleInline: {
        user: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { type: 'string', min: 6, message: '密码最小长度不能小于6位有效字符', trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ]
      },
      ccode: '' // 验证码
    }
  },
  mounted () {
    this.generatedCode()
  },
  methods: {
    handleSubmit () {
      this.$refs['formInline'].validate((valid) => {
        if (valid) {
          let loginBean = {
            password: this.formInline.password,
            username: this.formInline.user.trim(),
            appid: this.$store.state.main.appid
          }

          loginByUsername(loginBean).then(res => {
            if (!res.errcode && (res.roles.length > 0 || res.userInfo.stationRole.length > 0)) {
              let loginResult = checkReturnUrl(res.userInfo)
              let privateKey = loginResult.privateKey
              let urlLoader = loginResult.url

              const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(loginBean), privateKey).toString()
              setTimeout(() => {
                window.location.href = urlLoader + '?token=' + encodeURIComponent(ciphertext)
              }, 200)
            } else {
              // 登录失败， 显示错误消息
              this.pageView.showMessage = true
              if (res.userInfo && res.userInfo.stationRole.length === 0) {
                this.pageView.message = '当前用户未配置权限， 请联系管理员'
              } else {
                this.pageView.message = res.errmsg
              }
            }
          })
        }
      })
    },
    generatedCode () {
      const random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
        'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
      let code = ''
      for (let i = 0; i < 4; i++) {
        let index = Math.floor(Math.random() * 36)
        code += random[index]
      }
      this.ccode = code
    }
  }
}
</script>
